import { createFileRoute } from "@tanstack/react-router";
import { ExperienceDeepLink } from "@/components/ExperienceDeepLink";
import bannerPoster from "@/assets/banner-poster.webp.asset.json";

const URL = "https://www.travelbackland.com/family";
const TITLE = "Family Nature Getaways in Arizona — Backland";
const DESC =
  "A family-friendly luxury nature escape — spacious tented suites, room to roam on 160 private acres, and stargazing under some of Arizona's darkest skies.";

export const Route = createFileRoute("/family")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: bannerPoster.url, fetchPriority: "high", type: "image/webp" } as any,
    ],
  }),
  component: () => <ExperienceDeepLink slug="family" />,
});
